import type {
    MessageStandardType,
    MessageStandardsClientInterface,
    UpdateTargetGroupsRequest,
    UpdateTargetGroupsResponse,
    GroupMappingType,
} from './messageStandardsClient.types';
import type { CursorPaginationResponse } from '~/services/api';
import type { AxiosPromise } from 'axios';
import BaseClient from '../BaseClient';
import type { CursorPaginationParams } from '../BaseClient.types';

export default class CorporateMessageStandardsClient extends BaseClient implements MessageStandardsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getMessageStandards(params?: CursorPaginationParams): AxiosPromise<CursorPaginationResponse<MessageStandardType>> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getMessageStandard(messageStandardId: number): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createMessageStandard(data: MessageStandardType): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateMessageStandard(messageStandardId: number, data: MessageStandardType): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteMessageStandard(messageStandardId: number): AxiosPromise<void> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getGroupMappings(): AxiosPromise<{ data: GroupMappingType[] }> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/group-mappings`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateTargetGroups(
        messageStandardId: number,
        data: UpdateTargetGroupsRequest
    ): AxiosPromise<UpdateTargetGroupsResponse> {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/${messageStandardId}/groups`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    getDefaultMessageStandard(): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/default-message-standard`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateDefaultMessageStandard(data: MessageStandardType): AxiosPromise<MessageStandardType> {
        const url = `/api/v3/teams/${this.teamId}/default-message-standard`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    getMessageStandardsGroupCounts(params: { custom_message_standard_ids: number[] }) {
        const url = `/api/v3/teams/${this.teamId}/custom-message-standards/group-counts`;
        return this.makeCoreApiRequest(url, 'post', params);
    }
}
